import { TypedDocumentNode } from 'urql'
import { urqlClient } from './client'

export const mutation = <Resp, Args extends {}>(
  gql: TypedDocumentNode,
  params: Args
) => {
  return urqlClient.mutation<Resp>(gql, params).toPromise()
}
